<template>
	<div>
		<v-layout wrap pa-4>
			<v-flex xs12 title>
				¿Desea anular el asiento {{ name }}?
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="loading"
				@cancel-button-clicked="$emit('close-modal')"
				@accept-button-clicked="$emit('confirm-cancel')"
			>
			</modal-sidebar-button>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'journal-cancel-form',
		props: {
			loading: {
				default: false,
				type: Boolean,
			},
			name: String,
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/journal/journal-cancel-form.vue